/**
 * Homepage AMZ rails — quantity stepper (− qty +) synced with cart.
 */
(function () {
  if (window.__amzHomeCartQtyBound) return;
  window.__amzHomeCartQtyBound = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function dispatchCartEvents(cart) {
    var payload = { cart: cart };
    ['cart:refresh', 'cart:updated', 'cart:item-added', 'cart:update'].forEach(function (name) {
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: payload }));
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: payload }));
    });
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'amz-home-cart-qty', cartData: cart });
    }
    if (window.IfFloatingCart && typeof window.IfFloatingCart.refresh === 'function') {
      window.IfFloatingCart.refresh();
    }
  }

  function updateCard(card, qty) {
    var addBtn = card.querySelector('[data-amz-add]');
    var ctrl = card.querySelector('[data-amz-qty-ctrl]');
    var num = card.querySelector('[data-amz-qty-num]');
    if (!addBtn || !ctrl) return;

    if (qty > 0) {
      addBtn.hidden = true;
      ctrl.hidden = false;
      if (num) num.textContent = qty > 99 ? '99+' : String(qty);
    } else {
      addBtn.hidden = false;
      ctrl.hidden = true;
    }
  }

  function applyFromCart(cart) {
    var items = (cart && cart.items) || [];
    var byVariant = Object.create(null);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var vid = String(item.variant_id);
      if (!byVariant[vid]) {
        byVariant[vid] = { qty: 0, key: item.key || '' };
      }
      byVariant[vid].qty += item.quantity || 0;
      byVariant[vid].key = item.key || byVariant[vid].key;
    }

    document.querySelectorAll('[data-amz-variant-id]').forEach(function (card) {
      var vid = card.getAttribute('data-amz-variant-id');
      if (!vid) return;
      var entry = byVariant[vid];
      var qty = entry ? entry.qty : 0;
      updateCard(card, qty);
      if (entry && entry.key) card.setAttribute('data-amz-line-key', entry.key);
      else card.removeAttribute('data-amz-line-key');
    });
  }

  function refresh() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyFromCart(cart);
        return cart;
      })
      .catch(function () {});
  }

  function setBusy(card, on) {
    var ctrl = card.querySelector('[data-amz-qty-ctrl]');
    if (!ctrl) return;
    ctrl.classList.toggle('is-busy', on);
    ctrl.querySelectorAll('button').forEach(function (b) {
      b.disabled = on;
    });
  }

  function changeQty(card, variantId, newQty) {
    var qty = Math.max(0, newQty);
    var lineKey = card.getAttribute('data-amz-line-key');
    setBusy(card, true);
    updateCard(card, qty);

    var body;
    if (lineKey) {
      body = JSON.stringify({ id: lineKey, quantity: qty });
    } else {
      var updates = Object.create(null);
      updates[String(variantId)] = qty;
      body = JSON.stringify({ updates: updates });
    }

    var url = lineKey ? root() + 'cart/change.js' : root() + 'cart/update.js';

    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: body,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (cart && cart.status) throw new Error(cart.description || cart.message || 'Cart update failed');
        applyFromCart(cart);
        dispatchCartEvents(cart);
        return cart;
      })
      .catch(function () {
        return refresh();
      })
      .finally(function () {
        setBusy(card, false);
      });
  }

  function handleStep(card, delta) {
    if (!card) return;
    var variantId = card.getAttribute('data-amz-variant-id');
    if (!variantId) return;
    var numEl = card.querySelector('[data-amz-qty-num]');
    var current = parseInt(numEl && numEl.textContent, 10) || 0;
    changeQty(card, variantId, current + delta);
  }

  function onQtyClick(e) {
    var minus = e.target.closest('[data-amz-qty-minus]');
    var plus = e.target.closest('[data-amz-qty-plus]');
    if (!minus && !plus) return;

    var card = e.target.closest('[data-amz-variant-id]');
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();
    handleStep(card, plus ? 1 : -1);
  }

  function onCartEvent(e) {
    var detail = e.detail;
    var cart = detail && (detail.cart || (detail.items ? detail : null));
    if (cart && cart.items) applyFromCart(cart);
    else refresh();
  }

  function bind() {
    refresh();
    document.addEventListener('click', onQtyClick, true);

    ['cart:updated', 'cart:item-added', 'cart:refresh', 'cart:update'].forEach(function (name) {
      document.addEventListener(name, onCartEvent);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && event.cartData.items) applyFromCart(event.cartData);
        else refresh();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  window.AmzHomeCartQty = {
    refresh: refresh,
    applyFromCart: applyFromCart,
    step: handleStep,
    changeQty: changeQty,
  };
})();
